import { motion } from 'framer-motion';
import type { IndustryCategory } from '../types';
import ServiceCard from './ServiceCard';

interface IndustrySectionProps {
  industry: IndustryCategory;
  index: number;
}

const IndustrySection: React.FC<IndustrySectionProps> = ({ industry, index }) => {
  const isEven = index % 2 === 0;
  const IconComponent = industry.icon;

  return (
    <section
      id={industry.id}
      className={`py-20 ${isEven ? 'bg-white' : 'bg-slate-50'}`}
      aria-labelledby={`${industry.id}-heading`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-start md:items-center mb-12">
          <div className={`p-3 rounded-xl mr-4 ${industry.colorClass}`} aria-hidden="true">
            <IconComponent size={32} />
          </div>
          <div>
            <h2 id={`${industry.id}-heading`} className="text-3xl font-bold text-slate-900">
              {industry.name}
            </h2>
            <p className="text-slate-500 mt-2 max-w-2xl">{industry.description}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {industry.services.map((service) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              <ServiceCard service={service} accentColor={industry.colorClass} />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustrySection;
